import UpdateIcon from "@mui/icons-material/Update";
import UpdateIconDesign from "../../../common/UpdateIconQMS";
//
function EditManual({ onUpdate }) {
  return (
    <UpdateIconDesign
      id="updateManualBtn"
      onClick={onUpdate} // Trigger the update logic
      sx={{
        minWidth: 80,
        height: 36,
        px: 2,
        py: 0.5,
      }}
      icon={<UpdateIcon />}
    >
      Update
    </UpdateIconDesign>
  );
}

export default EditManual;
